
import React from 'react';
import { Caregiver } from '../types';

const STAFF: Caregiver[] = [
  {
    id: '1',
    name: 'Nurse Rekha M.',
    role: 'Senior ICU Specialist',
    experience: '12 Years',
    imageUrl: 'https://images.unsplash.com/photo-1559839734-2b71f1536780?auto=format&fit=crop&q=80&w=400',
    verified: true,
    specialization: ['Critical Care', 'Cardiac Recovery']
  },
  {
    id: '2',
    name: 'Brother Arjun S.',
    role: 'Elder Care Specialist',
    experience: '8 Years',
    imageUrl: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=400',
    verified: true,
    specialization: ['Physiotherapy Assist', 'Elder Mobility']
  },
  {
    id: '3',
    name: 'Dr. Priya V.',
    role: 'Palliative Care Lead',
    experience: '15 Years',
    imageUrl: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&q=80&w=400',
    verified: true,
    specialization: ['Oncology', 'Wound Management']
  }
];

const Caregivers: React.FC = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-6">
          <div className="max-w-xl">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">Expertise You Can Trust</h2>
            <div className="flex mb-6">
              <div className="w-16 h-1 bg-[#2E4A96]"></div>
              <div className="w-16 h-1 bg-[#1CB496]"></div>
            </div>
            <p className="text-slate-600 text-lg font-medium leading-relaxed">
              Our care team isn't just qualified—they are your neighbors. We recruit exclusively from the Whitefield community to ensure 24/7 availability and zero delay in care.
            </p>
          </div>
          <button className="bg-white border-2 border-[#2E4A96] text-[#2E4A96] px-8 py-4 rounded-2xl font-bold hover:bg-[#2E4A96] hover:text-white transition-all shadow-sm">
            Meet the Full Team
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {STAFF.map((member) => (
            <div key={member.id} className="bg-white p-6 rounded-[2rem] shadow-sm hover:shadow-xl transition-all group">
              <div className="relative aspect-[4/5] overflow-hidden rounded-2xl mb-8">
                <img 
                  src={member.imageUrl} 
                  alt={member.name} 
                  className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-500"
                />
                <div className="absolute top-4 right-4 bg-white px-3 py-1.5 rounded-full flex items-center shadow-lg border border-slate-100">
                  <div className="w-2 h-2 bg-[#1CB496] rounded-full mr-2"></div>
                  <span className="text-[10px] font-extrabold text-[#1CB496] uppercase tracking-wider">Whitefield Verified</span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-1">{member.name}</h3>
              <p className="text-[#2E4A96] font-bold text-sm mb-4 uppercase tracking-wide">{member.role} • {member.experience}</p>
              <div className="flex flex-wrap gap-2">
                {member.specialization.map((spec, i) => (
                  <span key={i} className="text-[10px] bg-slate-50 text-slate-500 px-3 py-1.5 rounded-full uppercase tracking-widest font-bold border border-slate-100">
                    {spec}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Caregivers;
